import React, { useState } from "react";
import { motion } from "framer-motion";

export function LoadingButton(props) {
  const { loadAnimationDuration = 6, children, ...rest } = props;

  const [gradientPercent, setGradientPercent] = useState(90);

  return (
    <motion.button
      initial={{
        background: `linear-gradient(90deg,  var(--primary-cta) ${0}%, var(--grey-2) ${0}%)`,
      }}
      animate={{
        background: `linear-gradient(90deg, var(--primary-cta)  ${gradientPercent}%, var(--grey-2) ${gradientPercent}%)`,
        transition: {
          duration: gradientPercent === 0 || gradientPercent === 100 ? 0 : loadAnimationDuration,
          ease: "linear",
        },
      }}
      {...rest}
    >
      {children}
    </motion.button>
  );
}
